<script>
  import { onMount } from "svelte";
  import {
    PageHead,
    PageLoading,
    ErrorModal,
  } from "../../Components/Common/index.svelte";
  import { apiMethods } from "../../Services/index.svelte";
  import { isMobile } from "../../stores";
  import {
    getText,
    goToURL,
    showError,
    sortEnumAlphabetically,
  } from "../../Utils/utilFunctions.svelte";
    import CardLayout from "../../Components/Common/CardLayout.svelte";
    import Loader from "../../Components/Common/Loader.svelte";
    import SvelteTable from "../../Components/Common/SvelteTable.svelte";
    import TableFooter from "../../Components/Layout/Table/TableFooter.svelte";
    import MultiSearchSelect from "../../Components/Common/MultiSearchSelect.svelte";

  export let params = {};

  let isLoading = false,
    isLoadingRebates = false,
    isLoadingHospitals = false,
    isLoadingInsuranceFunds = false,
    hospitalsOptionsArr = [],
    searchHospitalsArr = [],
    insuranceFundsOptionsArr = [],
    searchInsuranceFundsArr = [],
    itemNoGapRebates = [],
    MBSItemKeys = [],
    mbsItemData = {},
    page = 0,
    pageSize = 25,
    count = 0,
    filters = {
      itemNum: null,
      hospitalIds: [],
      insuranceFundsIds: []
    }

  onMount(() => {
    if (params.id) {
      getMBSItemByItemId(params.id);
      loadHospitals();
      loadInsuranceFunds();
    }
  });


  const getMBSItemByItemId = async (id) => {
    isLoading = true;

    await apiMethods.getMethod.getMBSItemByItemId(id).then(async (res) => {
      if (res.itemNum) {
        mbsItemData = { ...res };
        if (mbsItemData.description) {
          const descCon = mbsItemData.description;
          delete mbsItemData.description;
          mbsItemData.description = descCon;
        }

        const hiddenKeys = [
          "RebateAHSA",
          "RebateFAI",
          "RebateTFS",
          "RebateTFSNoGap",
          "RebateTFSKnownGap",
          "RebateWorkCover",
          "RebateTAC",
          "RebateADFPref",
          "RebateRTENoGap",
          "RebateRTEKnownGap",
        ];

        const lowerCaseHiddenKeys = hiddenKeys.map((key) =>
          key.toString().toLowerCase(),
        );

        for (const key in mbsItemData) {
          if (!lowerCaseHiddenKeys.includes(key.toLowerCase()))
            MBSItemKeys.push(key);
        }

        //set initial filters
        filters = {
          ...filters,
          itemNum: res.itemNum
        }

        //load no gap rebates
        await loadNoGapProgramRebates(true); //with loading

      } else showError(res.error);
    });

    isLoading = false;
  };

  const loadNoGapProgramRebates = async (withLoading = false) => {
    try {
      var getfilters = {
        "filter[itemNum]": filters.itemNum
      };
      if(filters.hospitalIds.length) {
        getfilters = {
          ...getfilters,
          "filter[hospitalid]": filters.hospitalIds.join(",")
        };
      }
      if(filters.insuranceFundsIds.length) {
        getfilters = {
          ...getfilters,
          "filter[fundid]": filters.insuranceFundsIds.join(",")
        }
      }
      if(withLoading)
        isLoadingRebates = true;
      var res =  await apiMethods.getMethod.getNoGapProgramRebates(
          page * pageSize, 
          pageSize,
          getfilters
      );
      if (!res || res.error)
          showError(
              "Failed to load no gap rebates, please refresh the page and try again and contact support if the issue persists.",
          );
      else {
          itemNoGapRebates = res.results;
          count = res.total;
      }
      isLoadingRebates = false;
    }
    catch(err) {
      showError(err ?? "There was an error trying to fetch the no gap rebates for this item. Please refresh the page and try again, or contact support for asistance.")
    }
    
    
  }

  const noGapRebatesColumns = [
    {
      key: "hospitalKey",
      title: "Hospital",
      headerClass: "text-left pl-3 font-bold ",
      class: "text-left px-3 whitespace-nowrap overflow-hidden text-ellipsis",
      value: (v) => `<u class="cursor-pointer">${getText(v.hospital.name)}</u>`,
    },
    {
      key: "insuranceFundKey",
      title: "Insurance Fund",
      headerClass: "text-left pl-3 font-bold",
      class: "text-left px-3 text-left truncate",
      value: (v) => `<u class="cursor-pointer">${getText(v.insuranceFund.name)}</u>`,
    },
    {
      key: "tableNameKey",
      title: "Table Name",
      headerClass: "text-left pl-3 font-bold",
      class: "text-left px-3 text-left truncate",
      value: (v) => v.name ? getText(v.name) : "Default",
    },
    {
      key: "rebateKey",
      title: "Rebate",
      headerClass: "text-left pl-3 font-bold w-[120px]",
      class: "text-left px-3 text-left w-[120px] truncate",
      value: (v) => `<div class="truncate cursor-pointer">$${formatRebateValue(v.rebate)}</div>`,
    }
  ];

  const formatRebateValue = (v) => {
    if (v === null || v === undefined) return '';

    if (typeof v === 'number') {
      return v.toFixed(2);
    }

    return String(v);
  };

  const handleClickCell = (
      { target: { className, classList } },
      rowData,
      key,
  ) => {
      if (key == "hospitalKey") {
          goToURL(`/Hospitals/view/${rowData.hospitalId}`);
      }
      if (key == "insuranceFundKey") {
          goToURL(`/InsuranceFunds/view/${rowData.fundId}`);
      }
  };

  const onPageChange = (e) => {
      page = Number(e.detail.page);

      loadNoGapProgramRebates();
  };

  const onPageSizeChange = (newPageSize) => {
      pageSize = newPageSize;
      page = 0;

      loadNoGapProgramRebates();
  };

  const handleHospitalChange = (
      searchResult = [],
      { requireReloadFunction = true },
  ) => {
      page = 0;
      searchHospitalsArr = filters.hospitalIds = [...searchResult];

      requireReloadFunction && loadNoGapProgramRebates();
  };

  const handleInsuranceFundChange = (
      searchResult = [],
      { requireReloadFunction = true },
  ) => {
      page = 0;
      searchInsuranceFundsArr = filters.insuranceFundsIds = [...searchResult];

      requireReloadFunction && loadNoGapProgramRebates();
  };

  const loadHospitals = async () => {
    isLoadingHospitals = true;

    hospitalsOptionsArr = [];

    await apiMethods.getMethod
        .getHospitals(0, 999999, {
        })
        .then((res) => {
            if (res.results && res.results.length) {
                res.results.map((hospital) => {
                    const { id, name } =
                        hospital;

                    hospitalsOptionsArr.push({
                        key: id,
                        value: name
                    });
                });
            }
        });

    isLoadingHospitals = false;
  };

  const loadInsuranceFunds = async () => {
    isLoadingInsuranceFunds = true;

    hospitalsOptionsArr = [];

    await apiMethods.getMethod
        .getInsuranceFund(0, 999999, {
        })
        .then((res) => {
            if (res.results && res.results.length) {
                res.results.map((fund) => {
                    const { id, name } =
                        fund;

                    insuranceFundsOptionsArr.push({
                        key: id,
                        value: name
                    });
                });
            }
        });

    isLoadingInsuranceFunds = false;
  };


  const getDisplayKey = (key) => `${key}:`;
</script>

{#if isLoading}
  <PageLoading />
{:else}
  <div class="flex flex-1 flex-col gap-2">
    <PageHead title="View MBS Item" />
    <CardLayout title= "MBS Item details">
      <div
        class="flex-1 px-2 py-4 w-full {$isMobile
          ? 'flex flex-col gap-y-2'
          : 'grid-cols-3 gap-3 grid grid-flow-row-dense'}"
      >
        <div class="flex col-span-3 font-bold">
          {mbsItemData["description"]}
        </div>
        <div class="flex flex-col gap-y-1 col-span-3">
          <p class="w-48 capitalize">
            {getDisplayKey("id")}
            {mbsItemData["id"]}
          </p>
        </div>
        {#each MBSItemKeys.filter((key) => key != "description" && key != "id").sort( (a, b) => sortEnumAlphabetically(a, b), ) as key}
          <div class="flex flex-row col-span-1">
            <p class="w-auto capitalize">{getDisplayKey(key)}</p>
            <p class="w-auto ml-3">{mbsItemData[key]}</p>
          </div>
        {/each}
      </div>
    </CardLayout>
    <CardLayout title = "No Gap Programs Rebates" cardClass="h-[600px]">
      {#if isLoadingRebates}
        <div class="flex flex-1 gap-x-4 items-center p-4">
          <Loader />
          <p>Fetching no gap rebates</p>
        </div>
      {:else}
        <div class="flex flex-col gap-y-2 h-[100%]">
          <div class="p-4 flex flex-row gap-2">
              {#if !isLoadingHospitals}
                  <MultiSearchSelect
                      title="Filter by Hospital"
                      inputID="filterHospital"
                      isDisabled={isLoadingRebates}
                      optionsArr={hospitalsOptionsArr}
                      bind:searchResult={searchHospitalsArr}
                      onChangeFunc={handleHospitalChange}
                      inputClass="w-[300px] !bg-white"
                      zIndex="94"
                  />
              {/if}
              {#if !isLoadingInsuranceFunds}
                  <MultiSearchSelect
                      title="Filter by Insurance Fund"
                      inputID="filterInsuranceFund"
                      isDisabled={isLoadingRebates}
                      optionsArr={insuranceFundsOptionsArr}
                      bind:searchResult={searchInsuranceFundsArr}
                      onChangeFunc={handleInsuranceFundChange}
                      inputClass="w-[300px] !bg-white"
                      zIndex="94"
                  />
              {/if}
          </div>
          <div class="flex flex-1 overflow-scroll">
            {#if itemNoGapRebates.length}
              <SvelteTable 
                columns={noGapRebatesColumns} 
                rows={itemNoGapRebates}
                clickCellFunc={({ detail: { event, row, key } }) => {
                  handleClickCell(event, row, key);
              }}
              />
            {:else}
              <div class="grid flex-1 h-full card bg-white rounded-box">
                <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row p-2">
                  <p>No Gap Rebates were not found </p>
                </div>
              </div>
            {/if}
          </div>
          <div class="p-2">
            <TableFooter
                {page}
                {pageSize}
                {count}
                showSelected
                selectedCount={itemNoGapRebates.length}
                tableData={itemNoGapRebates}
                {onPageChange}
                {onPageSizeChange}
            />
          </div>
        </div>
      {/if}
    </CardLayout>
  </div>
  
{/if}
